import { render, staticRenderFns } from "./RewardRecords.vue?vue&type=template&id=51ac4310"
import script from "./RewardRecords.vue?vue&type=script&setup=true&lang=js"
export * from "./RewardRecords.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports